'use strict'

import { useSelector } from 'react-redux'

export const getCurrencies = () => {
  return getStateWithSelector('currencyReducer', 'currencies')
}

export const getRates = () => {
  return getStateWithSelector('ratesReducer', 'rates')
}

export const getIpInfo = () => {
  return getStateWithSelector('ipReducer', 'ipInfo')
}

export const getLoading = () => {
  return getStateWithSelector('utilsReducer', 'loading')
}

const getStateWithSelector = (reducer, value) => {
  return useSelector(state => state.rootReducer[reducer][value])
}
